module.exports = __webpack_public_path__ + "img/journal.18e001c1.svg";